import { Component, ChangeDetectorRef, ElementRef } from '@angular/core';
import { M27Dialog, DialogBase } from '@m27/common';
import { ResearchAuthService } from '@core/authentication';


@Component({
    selector: 'app-dialog-login',
    templateUrl: './dialog-login.component.html',
    styleUrls: ['./dialog-login.component.scss']
})
export class LoginDialogComponent extends DialogBase implements M27Dialog {
    constructor(cd: ChangeDetectorRef, private auth: ResearchAuthService, elRef: ElementRef) {
        super(cd, elRef);

        window.addEventListener('message', this.silentRefreshPostMessageEventListener, false);
    }

    private silentRefreshPostMessageEventListener: EventListener = (e: MessageEvent) => {
        const message: string = e.data;

        if (message === 'closeMe') {
            this.close();
        }
    }

    public open(closeAll: boolean = false) {
        this.onOpenAlertConfirm.emit();
        this.modal.open();
    }

    public login(): void {
        this.auth.login();
    }

    public onDialogReady(): void {
    }

    onDestroy(): void {
        window.removeEventListener('message', this.silentRefreshPostMessageEventListener);
    }

    canCancel(): boolean {
        return false;
    }
}
